import { render, staticRenderFns } from "./LayBody.vue?vue&type=template&id=18039ea0&scoped=true&"
import script from "./LayBody.vue?vue&type=script&lang=js&"
export * from "./LayBody.vue?vue&type=script&lang=js&"
import style0 from "./LayBody.vue?vue&type=style&index=0&id=18039ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18039ea0",
  null
  
)

export default component.exports